import type { FaireProductEntity } from "../../entity_types/product";

export const p_vadrzb5u7v: FaireProductEntity = {
  token: "p_vadrzb5u7v",
  type: "product",
  name: "33140SET Round Neck Sweatshirt & Elastic Waist Shorts Set",
  brandToken: "b_ru6an13eof",
  brandName: "Blue B",
  imageUrl:
    "https://cdn.faire.com/fastly/5c6f6f7817377ece3136b8b9fd1cadc2330b0e11ab0a5c17b9dce65391ef64fa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/573624d1e90c08a691e3c5615e3886c0540c72d2d7515b31b3200dfae9a5c471.jpeg",
    "https://cdn.faire.com/fastly/c1513bd3f2900352694f1a34e68aaf8c4b496e5118a3eb0a1093fc0d3a971e13.jpeg",
    "https://cdn.faire.com/fastly/bfbf15ee05b999183d461b3f9d429876e3c5a0b7cc3df3e83ffb44b5035665af.jpeg",
    "https://cdn.faire.com/fastly/e83f315568dd5f66944582f9d9438cd3d62cc1d976ba233e076519b1d1f82311.jpeg",
    "https://cdn.faire.com/fastly/a151e52817b41b78b1dbd94add7d3c64fec21a3a6f1c2cb0c37ed013054f9116.jpeg",
    "https://cdn.faire.com/fastly/7b478fe3351e1424fb61c9c5f720afc6961f46b5f9f8fea3d01d5dbcfcaeeac1.jpeg",
    "https://cdn.faire.com/fastly/6fd3b2daa2126ac79ffdbd50888b34a82e0661c6d771c3672cd83dff718acaa5.jpeg",
    "https://cdn.faire.com/fastly/6163f149e695593d0d67d5be63941d7b84b9dbaf3c1ea1c353524d256ba943f1.jpeg",
  ],
  priceDollars: 21.9,
  description:
    "Soft velvety lounge set featuring a relaxed round-neck sweatshirt with long sleeves and matching elastic-waist shorts, both designed in a plush textured finish for a cozy yet stylish look.\n\n70% Tencel, 25% Polyester, 5% Spandex\nModel is 5'8\" tall and wearing size Small.",
  tags: [],
  msrpDollars: 43.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:49.642Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
